import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const BrandRPLogoIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M 1 3.553292 L 1 9 L 6.446708 9 L 8.999881 6.447173 L 8.999881 1.000464 L 3.553173 1.000464 L 1 3.553292 Z M 7.638111 7.638922 L 2.361745 7.638922 L 2.361745 2.361865 L 7.638111 2.361865 L 7.638111 7.638922 Z" />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const BrandRPLogoIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M 1 3.553292 L 1 9 L 6.446708 9 L 8.999881 6.447173 L 8.999881 1.000464 L 3.553173 1.000464 L 1 3.553292 Z M 7.638111 7.638922 L 2.361745 7.638922 L 2.361745 2.361865 L 7.638111 2.361865 L 7.638111 7.638922 Z" />
        </SvgIcon>
    );
};
